import React, {Component} from 'react'
import {_getListBilling} from "../../../../../services/apis/BillingsService"
import {Alert} from "reactstrap"
import Pagination from "./Pagination"
import BillingRecord from "./BillingRecord"
import {changeQuerySearch, parseSearchQuery} from "../../../../../helpers/routes/RouterHelper"

const _getInitPage = () => {
    const parsed = parseSearchQuery()
    return parsed.page ? parseInt(parsed.page, 10) : 1
}

class BillingsPage extends Component {
    state = {
        docs: [],
        total: 0,
        pagination: {
            page: _getInitPage(),
            limit: 1000,
            maxPage: 1,
        },
        error: '',
    }

    _refresh = null

    _fetchBillingsPage = () => {
        const {page, limit} = this.state.pagination

        _getListBilling(page, limit)
            .then(result => {
                const {success, data} = result

                if (success) {
                    const {total, docs, pages, limit} = data

                    this.setState(prevState => ({
                        total,
                        docs,
                        pagination: {
                            ...prevState.pagination,
                            limit: limit || 1000,
                            maxPage: pages,
                        }
                    }))
                } else {
                    this.setState({
                        error: result.message,
                    })
                }
            })
    }

    _handleChangePage = (page) => {
        changeQuerySearch({page})
        this.setState(prevState => ({
                pagination: {
                    ...prevState.pagination,
                    page,
                }
            })
        )
    }

    componentDidMount() {
        this._fetchBillingsPage()
        this._refresh = setInterval(() => {
            this._fetchBillingsPage()
        }, 5000)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.pagination.page !== this.state.pagination.page) {
            this._fetchBillingsPage()
        }
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    render() {
        const {total, pagination, error, docs} = this.state
        return (
            <div>
                {
                    !!error ? <Alert color="danger">{error}</Alert> :
                        <div className='BillingPage'>
                            <h2>Billing({total})</h2>
                            <div>

                                <div className='row table-row'>
                                    <div className='col-3'>Name</div>
                                    <div className='col-3'>Plan</div>
                                    <div className='col-2'>Coupon</div>
                                    <div className='col'>Method</div>
                                    <div className='col'>Created</div>
                                    <div className='col'>Price</div>
                                </div>
                                {
                                    docs.map((billingRecord) => {
                                        return (
                                            <BillingRecord
                                                key={'billing-record' + billingRecord._id}
                                                billingRecord={billingRecord}
                                            />
                                        )
                                    })
                                }
                            </div>
                            <Pagination paginationInfo={pagination} onChangePage={this._handleChangePage}/>
                        </div>
                }
            </div>
        )
    }
}

export default BillingsPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/billings/BillingsPage/BillingsPage.js